//
//
//
//

import {UserService} from '@nuskin/ns-account';
import {isNullOrEmpty} from '@nuskin/ns-common-lib';
import {nuskin, events} from '@nuskin/ns-util';
export default {
  name: 'UserState',
  data() {
    return {
      isLoggedIn: false,
      user: {}
    };
  },
  computed: {
    runConfig() {
      return this.$store.state.nuskin.runConfig || {};
    }
  },
  watch: {
    runConfig() {
      this.updateUserState();
    }
  },
  mounted() {
    this.addListeners();
    nuskin.eidLogin();
    this.updateUserState();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    updateUserState() {
      if (isNullOrEmpty(this.runConfig)) {
        return;
      }

      const user = UserService.getUser();
      this.isLoggedIn = !isNullOrEmpty(user);
      this.user = this.isLoggedIn ? user : {};

      const setData = {
        user: this.user,
        isLoggedIn: this.isLoggedIn
      };
      this.$store.commit('user/set', setData);
    },

    addListeners() {
      // listen to user changes
      events.subscribe(events.authentication.LOGIN, this.updateUserState);
      events.subscribe(events.authentication.LOGOUT, this.updateUserState);
    },

    removeListeners() {
      // stop listening to user changes
      events.unsubscribe(events.authentication.LOGIN, this.updateUserState);
      events.unsubscribe(events.authentication.LOGOUT, this.updateUserState);
    }
  }
};
